// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2hpn7","left":"StickyBox_left__3WJjQ","right":"StickyBox_right__1l8sJ"};